module.exports = __webpack_public_path__ + "static/img/互动投影.47895585.png";